/** Functions for time-of-day filters */

import { Map, List, Set } from 'immutable'
import moment from 'moment'


/** Sequence of times of day */
export const timesOfDay = List.of('Morning','Afternoon','Evening')

/** Given a sequence of offers, produces a 'filter index' -
 * a tree structure to power a filter UI.
 */

export const createFilterIndex = (offers = List(), requested = List()) =>
    offers.reduce( (idx, offer) =>
        offer.get('serviceDetail', List()).reduce( (idx, service, key) =>
            idx.update(routeDepartureKey(requested.get(key)), (m = Map()) =>
                m.update(todDepartureKey(service), (tod = Map()) =>
                    tod.update( 'lowest', prevLow => {
                        const offerCost = offer.getIn(['cost','amount'])
                        return prevLow == null || offerCost < prevLow
                            ? offerCost
                            : prevLow
                    })
                        .update( 'highest', prevHigh => {
                            const offerCost = offer.getIn(['cost','amount'])
                            return prevHigh == null || offerCost > prevHigh
                                ? offerCost
                                : prevHigh
                        })
                        .update( 'offers', (offers = Set()) =>
                            offers.add( offer.get('uri')))
                        .withMutations( m =>
                            m.set( 'offerCount', m.get('offers', Set()).size)
                        )
                )
            ).update(routeArrivalKey(requested.get(key)), (m = Map()) =>
                m.update(todArrivalKey(service), (tod = Map()) =>
                    tod.update( 'lowest', prevLow => {
                        const offerCost = offer.getIn(['cost','amount'])
                        return prevLow == null || offerCost < prevLow
                            ? offerCost
                            : prevLow
                    })
                        .update( 'highest', prevHigh => {
                            const offerCost = offer.getIn(['cost','amount'])
                            return prevHigh == null || offerCost > prevHigh
                                ? offerCost
                                : prevHigh
                        })
                        .update( 'offers', (offers = Set()) =>
                            offers.add( offer.get('uri')))
                        .withMutations( m =>
                            m.set( 'offerCount', m.get('offers', Set()).size)
                        )
                )
            )
            ,idx)
        , Map())


const routeDepartureKey = (service = Map()) =>
    `From ${service.get('from')}`

const todDepartureKey = (service = Map()) =>
    classifyTOD( moment(service.get('commence')))

const routeArrivalKey = (service = Map()) =>
    `To ${service.get('to')}`

const todArrivalKey = (service = Map()) =>
    classifyTOD( moment(service.get('complete')))

// const iataFromUri = uri =>
//     uri.substring(uri.length - 3)

const classifyTOD = (m = moment()) => {
    const hr = m.get('hour')
    return hr >= 0 && hr < 12
        ? 'Morning'
        : hr >= 12 && hr < 18
            ? 'Afternoon'
            : 'Evening'
}


/** Predicate (for .filter()) which uses a time-of-day spec in
 * the form:
 *
 *{
 *   "From JNB": {
 *       "Evening": true
 *   },
 *   "From MUC": {
 *       "Afternoon": true,
 *       "Morning": true
 *   }
 *}
 * to include or exclude options.
 * Note: Assumes that `todFilterSpec` is sparse - no empty sub-maps.
 */
export const timeOfDayPredicate = ( todFilterSpec = Map() ) => (offer = Map() ) =>
  {
    // FIXME this doesn't seem to be the ideal way to do this. The obvious assumption is that we will have
    // this requested object set in the offer when called.
    const requested = offer.get("requested", List())
    if (todFilterSpec.isEmpty())
    {
      return todFilterSpec.isEmpty();
    }

    if (offer.has('serviceDetail'))
    {
      return offer.get('serviceDetail')
      .every( serviceMatches.bind(null, todFilterSpec, requested) )
    }

    // for combined offers
    return offer.get('serviceAlternatives')
            .every( (sa, k ) => sa.get('serviceDetail').some( (sd,sdk) => serviceMatches(todFilterSpec, requested, sd, k)) )
  }


/** Predicate: Service must match the given spec. For the spec entry
 * matching the service's route, the service must match ANY of the
 * times of day within, or otherwise not match any spec entry
 * at all.
 */
const serviceMatches = ( todFilterSpec = Map(), requested, service = Map(), key ) => {
    const rdKey = routeDepartureKey(requested.get(key))
    const tdKey = todDepartureKey(service)
    const raKey = routeArrivalKey(requested.get(key))
    const taKey = todArrivalKey(service)
    return (todFilterSpec.has(rdKey)
        ? todFilterSpec.get(rdKey).has(tdKey)
        : true) && (todFilterSpec.has(raKey)
            ? todFilterSpec.get(raKey).has(taKey)
            : true)
}



// WEBPACK FOOTER //
// ./src/ndc/offer/filters/timeOfDay/timeOfDay.js